import { booleanAttribute, Directive, Input, Optional } from '@angular/core';
import { MapDynamicData } from 'libs/map/src/lib';
import { mergeFeatureCollectionWithSprites } from 'libs/map/src/lib/flyfreely-map/helpers';
import { Subject, takeUntil } from 'rxjs';
import { MissionNoticesDataService } from './notices-shared/mission-notices-data.service';

@Directive({
    selector: 'flyfreely-map[notices]',
    standalone: true
})
export class MapNoticesDirective {
    /**
     * Should this directive be enabled
     */
    @Input({ transform: booleanAttribute }) notices = true;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private dynamicDataService: MapDynamicData,
        @Optional() private noticesService: MissionNoticesDataService
    ) {}

    ngOnInit() {
        if (this.noticesService == null && this.notices) {
            console.warn(
                'MapNoticesDirective is missing the MissionNoticesDataService but is not explicity disabled with notices=false'
            );
        } else if (this.noticesService != null && this.notices) {
            this.noticesService.lotams$
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(notices => {
                    this.dynamicDataService.setProgrammaticMapConfig(this, {
                        enabledLayerGroups: ['LOTAM'],
                        mapData: {
                            LOTAM: mergeFeatureCollectionWithSprites(
                                notices.map(n => n.displayLocation)
                            )
                        }
                    });
                });
        }
    }

    ngOnDestroy() {
        this.dynamicDataService.clearProgrammaticMapConfig(this);
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}
